import { render } from "./TheLanguagePicker.vue?vue&type=template&id=d8d9ac48&scoped=true"
import script from "./TheLanguagePicker.vue?vue&type=script&lang=js"
export * from "./TheLanguagePicker.vue?vue&type=script&lang=js"

import "./TheLanguagePicker.vue?vue&type=style&index=0&id=d8d9ac48&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d9ac48"]])

export default __exports__